import { memo } from 'react';
import type { ReactNode } from 'react';

import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material';

import { checkIfIsArray } from '@e-socna/utils';
import { EMPTY_ARRAY } from '@e-socna/empty';

interface Props {
  readonly children: ReactNode;
  readonly sx?: SxProps<Theme>;
}

// MHO : from https://codesandbox.io/s/pdf-viewer-w7wpu
const PageCmp = ({ children, sx = EMPTY_ARRAY }: Readonly<Props>) => (
  <Box
    sx={[
      ...(checkIfIsArray(sx) ? sx : [sx]),
      {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    ]}
  >
    {children}
  </Box>
);

export const Page = memo(PageCmp);

Page.displayName = 'Page';
